export const FIELDS = {
  ID: 'id',
  PURCHASE_ORDER_LINE_ID: 'purchaseOrderLineId',
  RMA_LINE_ID: 'rmaLineId',
  PART_ID: 'partId',
  DATE_CREATED: 'dateCreated',
  PURCHASE_ORDER_ID: 'purchaseOrderId',
  PART_NUMBER: 'partNumber',
  VENDOR_ID: 'vendorId',
  MFR_NAME: 'mfrName',
  VENDOR_NAME: 'vendorName',
  ORIGINATOR_NAME: 'originatorName',
  MFR_ID: 'mfrId',
  DATE_INSPECTED: 'dateInspected',
  QUANTITY: 'quantity',
  NCNUMBER: 'ncNumber',
  DWG_NUMBER: 'dwgNumber',
  NCMACTIVITY_INSPECTION_ID: 'ncmActivityInspectionId',
  NCMACTIVITY_INSPECTION_NAME: 'ncmActivityInspectionName',
  DESCRIPTION: 'description',
  ACTION: 'action',
  NCMDISPOSITION_ACTION_ID: 'ncmDispositionActionId',
  NCMDISPOSITION_ACTION: 'ncmDispositionAction',
  RESPONSIBLE_MANAGER: 'responsibleManager',
  RESPONSIBLE_MANAGER_DATE: 'responsibleManagerDate',
  IS_CRITICAL_NCFOR_USE_AS_IS_DISPOSITION: 'isCriticalNcForUseAsIsDisposition',
  PROJECT_ENGINEER: 'projectEngineer',
  PROJECT_ENGINEER_DATE: 'projectEngineerDate',
  PROJECT_MANAGEMENT: 'projectManagement',
  PROJECT_MANAGEMENT_DATE: 'projectManagementDate',
  DISPOSITION_APPROVED_BY: 'dispositionApprovedBy',
  DISPOSITION_APPROVED_DATE: 'dispositionApprovedDate',
  CORRECTIVE_ACTION_DESCRIPTION: 'correctiveActionDescription',
  CORRECTIVE_ACTION_APPROVED_BY: 'correctiveActionApprovedBy',
  CORRECTIVE_ACTION_APPROVED_DATE: 'correctiveActionApprovedDate',
  CLOSING_NCM_BY: 'closingNcmBy',
  CLOSING_NCM_DATE: 'closingNcmDate',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  ACTIVE: 'active',};